var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "105", height: "66", viewBox: "0 0 105 66", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Artboard"
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { d: "M40.696 34.93l5.742-7.598c3.016 2.61 7.54 3.828 10.498 3.828 3.828 0 5.626-1.392 5.626-2.958 0-1.392-.812-2.494-5.974-2.494-1.682 0-5.046.058-5.626.116v-9.918c.754.058 4.234.058 5.626.058 3.712 0 5.336-.928 5.336-2.32 0-1.798-2.378-2.784-5.742-2.784-3.306 0-6.96 1.392-9.628 3.596L41.218 7.38C44.64 3.61 49.918 1 57.458 1 68.13 1 73.582 5.35 73.582 11.73c0 4.118-3.596 7.772-8.526 8.584 4.292.464 9.164 3.712 9.164 9.048 0 6.902-6.786 11.6-16.82 11.6-7.656 0-13.456-2.552-16.704-6.032z", stroke: "#2D9F86", fill: "#FFF" }),
      React.createElement("path", { d: "M102.5 63.766H2.5", stroke: "#DCF0EE", strokeWidth: "5", strokeLinecap: "square" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/static/images/number-3.svg